import React, { Component } from 'react'
import StartFooter from './StartFooter'
import LicencjaHeader from './LicencjaHeader'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'
import ErrorDialog from '../ErrorDialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import { regulaminURL, politykaPrywatnosciURL } from '../../lib/consts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons'

class Login extends Component {
  state = {
    email: '',
    password: '',
    errorEmail: false,
    errorPassword: false,
  }

  getErrorContent(error) {
    return (
      <DialogContent>
        <DialogContentText>
          Przykro nam, ale nie udało się zalogować.
        </DialogContentText>
        <br />
        <DialogContentText>{error}</DialogContentText>
      </DialogContent>
    )
  }

  validateEmail() {
    if (!this.state.email) {
      this.setState({ errorEmail: true })
      return false
    }
    return true
  }

  validatePassword() {
    if (!this.state.password || this.state.password.length < 8) {
      this.setState({ errorPassword: true })
      return false
    }
    return true
  }

  checkValidity() {
    let result = true
    this.setState({
      errorEmail: false,
      errorPassword: false,
    })
    if (!this.validateEmail()) result = false
    if (!this.validatePassword()) result = false
    return result
  }

  changeEmail(value) {
    this.setState({
      email: value,
    })
  }

  changePassword(value) {
    this.setState({
      password: value,
    })
  }

  render() {
    const { onLogin, onCancel, error, onCloseError } = this.props
    return (
      <>
        <section>
          <div className="header">
            <div className="imgContainer">
              <FontAwesomeIcon
                icon={faArrowLeft}
                onClick={onCancel}
                alt="wstecz"
              />
            </div>
            <LicencjaHeader />
          </div>
          <main>
            <h2 className="loginHeader">Zaloguj się</h2>
            <form>
              <FormControl component="fieldset" error={this.state.errorEmail}>
                <TextField
                  type="email"
                  error={this.state.errorEmail}
                  defaultValue={this.state.email}
                  onChange={e => this.changeEmail(e.target.value)}
                  name="email"
                  label="Adres email"
                  aria-describedby="email-error-text"
                />
                {this.state.errorEmail && (
                  <FormHelperText id="email-error-text">
                    Niepoprawna wartość pola
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl
                component="fieldset"
                error={this.state.errorPassword}
              >
                <TextField
                  error={this.state.errorPassword}
                  type="password"
                  defaultValue={this.state.password}
                  onChange={e => this.changePassword(e.target.value)}
                  name="haslo"
                  label="Hasło"
                  aria-describedby="password-error-text"
                />
                {this.state.errorPassword && (
                  <FormHelperText id="password-error-text">
                    Niepoprawna wartość pola
                  </FormHelperText>
                )}
              </FormControl>
            </form>
            <Button
              className="buttonLogin"
              variant="contained"
              color="primary"
              onClick={() => {
                if (this.checkValidity())
                  onLogin(this.state.email, this.state.password)
              }}
            >
              ZALOGUJ
            </Button>
          </main>
          <p className="disabled-subtitle-2 regulaminLoginText">
            Zalogowanie się oznacza akceptację
            <span className="link disabled-subtitle-2">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={regulaminURL}
                className="disabled-subtitle-2 regulaminLink"
              >
                &nbsp;regulaminu&nbsp;
              </a>
            </span>
            oraz
            <span className="link disabled-subtitle-2">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={politykaPrywatnosciURL}
                className="disabled-subtitle-2 regulaminLink"
              >
                &nbsp;polityki prywatności.&nbsp;
              </a>
            </span>
          </p>
        </section>
        <footer>
          <StartFooter />
        </footer>
        <ErrorDialog
          error={error}
          title={'Nie udało się zalogować'}
          content={this.getErrorContent(error)}
          onCloseDialog={onCloseError}
        />
      </>
    )
  }
}

export default Login
